(
    function() {
        module.exports = {
            addInspecletTag: function(wid) {
                window.__insp = window.__insp || [];
                // eslint-disable-next-line no-undef
                __insp.push(['wid', wid]);
                const insp = document.createElement('script');
                insp.type = 'text/javascript';
                insp.async = true;
                insp.id = 'inspsync';
                insp.src = ('https:' === document.location.protocol ? 'https' : 'http') +
                    `://cdn.inspectlet.com/inspectlet.js?wid=${wid}`;
                const x = document.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(insp, x);
            },
            initAndTagInspeclet: function(abArray, wid) {
                if (wid) {
                    this.addInspecletTag(wid);
                    const inspScript = document.querySelector('#inspsync');
                    inspScript.addEventListener('load', () => {
                        abArray.forEach((ab) => this.tagInspeclet(ab));
                    });
                }
            },
            tagInspeclet: function(ab) {
                    window.__insp.push(['tagSession', ab]);
            },
        };
    }
)();


